import { useMutation } from "react-query";
import http from "infra/http";

function useArquivarMensagem() {
  return useMutation(
    (id: string) => {
      return http.post(`/v1/mensagem/${id}/toggle-arquivar`);
    },
    { retry: false }
  );
}

export default useArquivarMensagem;
